// 对与request操作进行封装
import request from "@/utils/request.js";
import wx from "weixin-js-sdk";
// let baseApi = "/api";
/**
 * @param {*} url,
 * @param {*}  data
 */
export const apiPost = (url, data) => {
  return request({
    method: "POST",
    url: url,
    data: data
  });
};

/**
 * @param {*} url,
 * @param {*}  data
 */
export const apiGet = (url, data) => {
  return request({
    method: "GET",
    url: url,
    data: data
  });
};

/**
 * @param {*} url,
 * @param {*}  data
 */
export const queryPost = (url, data) => {
  return request({
    method: "POST",
    url: url,
    params: data
  });
};

/**
 * @param {*} url,
 * @param {*}  data
 */
export const queryGet = (url, data) => {
  return request({
    method: "GET",
    url: url,
    params: data
  });
};

export async function setWxConfig(localUrl) {
  var url = "https://b2c.youchalian.com/weixin/config/verificationUrl";
  let res = await queryPost(url, { url: localUrl })
    .then(response => {
      let data = response.data.data;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["scanQRCode", "chooseWXPay"]
      });
    })
    .catch(err => {
      console.log(err);
    });
  return res;
}

//判断访问终端
export const browser = {
  versions: (function() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    console.log(app);
    return {
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};

export function openInWebview() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 微信浏览器判断
    return false;
  } else if (ua.match(/QQ/i) == "qq") {
    // QQ浏览器判断
    return false;
  } else if (ua.match(/WeiBo/i) == "weibo") {
    return false;
  } else {
    if (ua.match(/Android/i) != null) {
      return ua.match(/browser/i) == null;
    } else if (ua.match(/iPhone/i) != null) {
      return ua.match(/safari/i) == null;
    } else {
      return ua.match(/macintosh/i) == null && ua.match(/windows/i) == null;
    }
  }
}
